module.exports = __webpack_public_path__ + "static/media/NominatePIN-Flexi.86d08b47.png";